<template>
    <div>
        
        <v-btn class="ml-4" color="primary" icon @click="openModal"><v-icon>add</v-icon></v-btn>
        
        <v-dialog v-model="showFormPermission" :persistent="!showFormPermissionViewMode" max-width="1000px" @close="close">
            <v-card>
                <v-card-title style="background: white; color: grey darken-2">
                    <span class="headline">{{title}} 
                        <span style="color: grey; margin-left: -5px" v-if="mForm.name">: {{mForm.name}}</span>
                    </span>
                </v-card-title>

                <v-tabs v-model="active_tab"
                        color="blue-grey darken-2 white--text"
                        dark
                        slider-color="blue-grey darken-1"
                        grow
                >
                    <!--Geral-->
                    <v-tab :key="'tab_general'" ripple >Geral</v-tab>
                    <v-tab-item :key="'tab_general'" >
                        <v-container style="padding: 20px 40px 20px 40px">
                            <v-layout wrap>
                                <v-flex xs12 px-2>
                                    <v-text-field
                                        v-model="mForm.name"
                                        label="Nome*"
                                        :error-messages="nameErrors"
                                        @blur="$v.mForm.name.$touch()"
                                        type="text"
                                        :dense="showFormPermissionViewMode"
                                        :outlined="showFormPermissionViewMode"
                                        :disabled="showFormPermissionViewMode"
                                    ></v-text-field>
                                </v-flex>
                                <v-flex xs12 sm6 md4 px-2 v-if="showFormPermissionViewMode">
                                    <span>Colaboradores presentes neste grupo:</span>
                                    <ul>
                                        <li v-for="(user) in selectedPermission.users" :key="user.id">
                                            <span>{{user.name}}</span>
                                            <span v-if="user && user.email" style="margin-left: 10px; color: #989898">({{user.email}})</span>
                                        </li>
                                        <li v-if="!selectedPermission.users || selectedPermission.users.length < 1">
                                            <span style="color: #898989">Nenhum</span>
                                        </li>
                                    </ul>
                                </v-flex>
                            </v-layout>
                        </v-container>
                        <v-divider></v-divider>
                    </v-tab-item>

                    <!-- Permissions -->
                    <v-tab :key="'tab_permissions'" ripple >Permissões</v-tab>
                    <v-tab-item :key="'tab_permissions'" >
                        <v-container style="padding: 20px 40px 20px 40px; max-height: 500px; overflow-y: auto;">
                            <div v-for="(section, index) in permissions" :key="index">
                                <v-layout wrap style="margin-bottom: -35px">
                                    <v-layout wrap>
                                        <v-flex shrink class="mr-2, mb-2"> <p style="font-weight: bold">{{section.label}}</p> </v-flex>
                                        <v-flex grow> <v-divider style="margin-top: 10px"></v-divider> </v-flex>
                                    </v-layout>
                                </v-layout>
                                <v-container grid-list-md>
                                    <v-layout  >
                                        <v-flex xs12 sm6 md4 px-2 style="margin-top: -20px" v-for="(permission, innerPropertyName, innerIndex) in section.permissions" :key="'inner'+innerIndex">
                                        <v-checkbox
                                            v-model="permissions[index].permissions[innerPropertyName].has"
                                            :disabled="showFormPermissionViewMode"
                                            :label="section.checkBoxlabels && section.checkBoxlabels.length > 0 ? section.checkBoxlabels[innerIndex] : '???'">
                                        </v-checkbox>
                                        </v-flex>
                                    </v-layout>
                                </v-container>
                                <v-layout wrap >

                                </v-layout>
                            </div>

                        </v-container>
                        <v-divider></v-divider>
                    </v-tab-item>

                </v-tabs>

                <v-card-actions>
                    <v-btn v-show="!saveLoading" depressed text @click="close">{{showFormPermissionViewMode ? 'Fechar' : 'Cancelar'}}</v-btn>
                    <v-spacer></v-spacer>

                    <v-btn v-if="active_tab !== 0" @click="active_tab--" text color="primary">Anterior</v-btn>
                    <v-btn v-if="active_tab < (Max_TABS-1)" :disabled="!checkStep1" @click="active_tab++" color="primary">Seguinte</v-btn>
                    <v-btn v-if="active_tab === (Max_TABS-1) && !showFormPermissionViewMode" class="white--text" color="blue darken-4" :disabled="!checkStep2" :loading="saveLoading" text @click="save">Guardar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
    import {maxLength, minLength, required, email} from 'vuelidate/lib/validators';
    import {permissions} from '../../permissions';
    export default {
        name: "GroupPermissionFormModal",
        mounted(){

        },

        data() {
            return {
                permissions: [...permissions],
                saveLoading: false,
                active_tab: 0,
                Max_TABS: 2,
                mForm: {
                    name: '',
                    branchIds: [],

                },
            }
        },

        props: ['branches'],

        validations: {
            mForm: {
                name: {
                    required,
                    minLength: minLength(2),
                    maxLength: maxLength(200),
                },

            },
        },

        watch:{
            showFormPermission(){
                if (this.showFormPermission){
                    this.onModalOpen();
                }else{
                    this.close();
                }
            }
        },

        methods: {
            onModalOpen(){
                if (!this.selectedPermission) {
                    this.close();
                    return;
                }
                this.consoleLog('onModelOpen', this.selectedPermission);

                if(this.isEditing){
                    this.mForm.name = this.selectedPermission.name;
                    this.setupSelectPermissions();
                }

                // this.mForm.branchIds = this.getBranchesIdByBranches();

            },


            openModal(){
                this.selectedPermission = {};
                this.showFormPermission = true;
            },

            setupSelectPermissions(){
                for(let i=0; i<this.permissions.length; i++){
                    let permissionSection = this.permissions[i];
                    Object.entries(permissionSection.permissions).forEach(([key, value]) => {
                        this.permissions[i].permissions[key].has = false;//resetting checkboxes to false
                        Object.entries(this.selectedPermission.permissions).forEach(([innerKey, innerValue]) => {
                            if(innerValue.id === value.value){
                                this.permissions[i].permissions[key].has = true; //setting checkboxes to true if has permission
                            }
                        });
                    });
                }
            },

            //gets the permissions key-value in a single object to be sent to the server
            getPermissionsKeyValues(){
                let obj = {};
                for(let i=0; i<this.permissions.length; i++){
                    let permissionSection = this.permissions[i];
                    Object.entries(permissionSection.permissions).forEach(([key, value]) => {
                        // console.log(`${key} ${value}`);
                        obj[key] = value;
                    });
                }
                return obj;
            },

            getPermissionsToSaveOnServer(){
                let permissionsToSend = [];
                for (let i=0; i<this.permissions.length; i++){
                    let perm = this.permissions[i];
                    Object.entries(perm.permissions).forEach(([key, value]) => {
                        // console.log(`${key} ${value}`);
                        if(value.has){
                            permissionsToSend.push(value.value);
                        }
                    });
                }
                // this.consoleLog('permissionsToSend', permissionsToSend);
                return permissionsToSend;
            },

            save(){

                if(this.isEditing) {
                    this.updateGroupPermission();
                }else{
                    this.addGroupPermission();
                }
            },

            addGroupPermission(){
                this.consoleLog('adding groupPermission');
                this.saveLoading = true;
                this.axios.post('group', {
                    name: this.mForm.name,
                    branch_ids: this.mForm.branchIds,
                    permissions:  this.getPermissionsToSaveOnServer(),
                })
                .then(response => {
                    this.consoleLog(response);
                    if (!response.data.success) {
                        this.saveLoading = false;
                        this.handleErrorCodeMessage(response.data);
                        return;
                    }
                    this.$store.dispatch('updateLoggedUserPermissions', response.data.response.loggedUserPermissions);
                    this.$emit('permissionAction');
                    this.close();
                    this.showSnackBar('permissões atualizadas com sucesso', 'green');
                }).catch(error => {
                    this.consoleLog(error);
                    this.showSnackBar('ocorreu um erro. Tente novamente...', 'red');
                }).finally(() => {
                    this.saveLoading = false;
                });
            },

            updateGroupPermission(){
                this.consoleLog('updating groupPermission');
                this.saveLoading = true;
                this.axios.put('group/'+this.selectedPermission.id, {
                    name: this.mForm.name,
                    branch_ids: this.mForm.branchIds,
                    permissions:  this.getPermissionsToSaveOnServer(),
                })
                .then(response => {
                    this.consoleLog(response);
                    if (!response.data.success) {
                        this.saveLoading = false;
                        this.handleErrorCodeMessage(response.data);
                        return;
                    }
                    if(response.data.response.logged_user_group){
                        this.$store.dispatch('loggedUser', response.data.response.logged_user_group);
                    }
                    this.$emit('permissionAction');
                    this.close();
                    this.showSnackBar('permissões atualizadas com sucesso', 'green');
                }).catch(error => {
                    this.consoleLog(error);
                    this.showSnackBar('ocorreu um erro. Tente novamente...', 'red');
                }).finally(() => {
                    this.saveLoading = false;
                });
            },

            close(){
                this.showFormPermission = false;
                this.showFormPermissionViewMode = false;
                this.selectedPermission = {};
                this.active_tab = 0;
                this.clearFormFields();
            },

            clearPermissionCheckBoxes(){
                for(let i=0; i<this.permissions.length; i++){
                    let permissionSection = this.permissions[i];
                    Object.entries(permissionSection.permissions).forEach(([key, value]) => {
                        permissionSection.permissions[key] = false;
                    });
                }
            },

            clearFormFields(){
                this.mForm.name = "";
                this.mForm.branchIds = [];
                // this.clearPermissionCheckBoxes();
                this.$v.$reset();
            },
        },

        computed: {

            title(){
                if(this.showFormPermissionViewMode) return 'Grupo & Permissôes';
                return this.isEditing ? 'Editando Grupo' : 'Novo Grupo'
            },

            isEditing(){
                return this.selectedPermission && this.selectedPermission.id
            },

            checkStep1(){
                return !this.$v.mForm.$invalid;
            },
            checkStep2(){
                return this.checkStep1 && true;
            },


            nameErrors(){
                const errors = [];
                if (!this.$v.mForm.name.$dirty) return errors;
                !this.$v.mForm.name.required && errors.push('Introduza nome.');
                !this.$v.mForm.name.maxLength && errors.push('Maximo '+this.$v.mForm.name.$params.maxLength.max+' caracteres.');
                !this.$v.mForm.name.minLength && errors.push('Minimo '+this.$v.mForm.name.$params.minLength.min+' caracteres.');
                return errors
            },

            validate () {
                return !this.$v.$invalid;
            },

            selectedPermission: {
                get(){
                    return this.$store.getters.getSelectedPermission;
                },
                set(value){
                    this.$store.dispatch('setSelectedPermission', value);
                }
            },
            showFormPermission: {
                get(){
                    return this.$store.getters.getShowFormPermission;
                },
                set(value){
                    this.$store.dispatch('setShowFormPermission', value);
                }
            },
            showFormPermissionViewMode: {
                get(){
                    return this.$store.getters.getShowFormPermissionViewMode;
                },
                set(value){
                    this.$store.dispatch('setShowFormPermissionViewMode', value);
                }
            },
        },
    }
</script>

<style scoped>

</style>